import React from "react";
import type { DocumentElement as DocumentElementType } from "@eaco/forms-core";

import PageRichText from "./PageRichText";
import { usePageTextBlock } from "./usePageTextBlock";

interface Props {
  element: DocumentElementType;
}

/**
 * A block quote: a left rule + rich text. Continues itself on Enter (its
 * `next_element` points back at `page-quote`); an empty line exits to text.
 */
const PageQuote: React.FC<Props> = ({ element }) => {
  const { richTextProps } = usePageTextBlock(element);
  return (
    <div className="border-l-[3px] border-[#37342f] py-[2px] pl-[16px]">
      <PageRichText {...richTextProps} />
    </div>
  );
};

export default PageQuote;
